<template>
  <div id="exam-by-subject-editor">
    <div class="-header">
      <div class="--title">
        <span>Add Exam Question</span>
      </div>
      <span class="--subtitle">เพิ่มข้อสอบ</span>
    </div>

    <div class="-body">
      <div class="--controllers">
        <vs-button @click="preview = !preview">{{ preview ? 'ปิดตัวอย่าง' : 'ดูตัวอย่าง' }}</vs-button>
        <label>คะแนนต่อข้อ</label>
        <input type="text" v-model.number="form.input.score">
        <vs-button @click="handleImportAll">Import ทั้งหมด</vs-button>
        <vs-button @click="handleImportSelected">Import ข้อสอบที่เลือก</vs-button>
      </div>
      <div class="--preview" v-if="preview">
        <vs-tabs>
          <template v-for="(sheet, index) in local.table.set">
            <vs-tab :label="(index + 1).toString() + ' ' + sheet" :key="index">
              <div class="con-tab-ejemplo">
                <vs-table :data="local.table.data[index]">
                  <template slot="header">
                    <h3>
                      ข้อสอบ {{ sheet }}
                    </h3>
                    <label>เลือกข้อสอบนี้</label>
                    <input v-model="form.selectedSheet" :value="index" type="checkbox">
                  </template>

                  <template slot="thead">
                    <vs-th>
                      No.
                    </vs-th>
                    <vs-th>
                      คำถาม
                    </vs-th>
                    <vs-th>
                      คำตอบ
                    </vs-th>
                    <vs-th>
                      ตัวเลือก 1
                    </vs-th>
                    <vs-th>
                      ตัวเลือก 2
                    </vs-th>
                    <vs-th>
                      ตัวเลือก 3
                    </vs-th>
                    <vs-th>
                      ตัวเลือก 4
                    </vs-th>
                    <vs-th>
                      สุ่ม
                    </vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data" style="border-bottom: 1px solid #ddd">
                      <vs-td :data="indextr" width="30">
                        {{ indextr + 1 }}
                      </vs-td>

                      <vs-td :data="data[indextr]['QUESTION']">
                        {{ data[indextr]["QUESTION"] }}
                      </vs-td>

                      <vs-td :data="data[indextr]['ANSWER']" width="100">
                        {{ data[indextr]["ANSWER"] }}
                      </vs-td>

                      <vs-td :data="data[indextr]['CHOICE1']" width="90">
                        {{ data[indextr]["CHOICE1"] }}
                      </vs-td>

                      <vs-td :data="data[indextr]['CHOICE2']" width="90">
                        {{ data[indextr]["CHOICE2"] }}
                      </vs-td>

                      <vs-td :data="data[indextr]['CHOICE3']" width="90">
                        {{ data[indextr]["CHOICE3"] }}
                      </vs-td>

                      <vs-td :data="data[indextr]['CHOICE4']" width="90">
                        {{ data[indextr]["CHOICE4"] }}
                      </vs-td>
                      
                      <vs-td :data="data[indextr]['CHOICE4']" width="80">
                        {{ data[indextr]["RANDOM"] === 0 ? "ไม่ใช่" : "ใช่" }}
                      </vs-td>

                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </vs-tab>
          </template>
        </vs-tabs>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, vue/no-unused-components */
import { state } from "../data";
import { loadData } from '../data/data-loader';
import { importAllExamQuestion, importSelectedExamQuestion } from "../data/data-handlers";
// import { transformCheckboxInputToCourseOutlineRegistrationInput } from "../data/data-modellers";
import Block from "@/components/common-ui/block/index.vue";
import InputBox from "@/components/common-ui/forms/input-box/index.vue";
import TextArea from "@/components/common-ui/forms/textarea/index.vue";
import SelectBox from "@/components/common-ui/forms/select-box/index.vue";

export default {
  components: {
    Block
  },
  data() {
    return {
      local: state.local,
      preview: false,
      // store: state.store,
      // selection: state.local.filterSelection,
      form: state.local.form,
      // list: state.local.list,
      // input: [],
    }
  },
  computed: {
    
  },
  methods: {
    async handleImportAll() {
      await importAllExamQuestion();

    },
    async handleImportSelected() {
      await importSelectedExamQuestion();
    }
    // handleCourseOutlineUnitSelect(data) {
    //   this.form.courseOutlineUnitId = data.multipleValues.courseOutlineUnitId;
    //   this.form.vdoSetUnitInput.unitSeq = data.multipleValues.unitSeq;
    // },
    // handleRemarkInput({ data }) {
    //   this.form.vdoSetUnitInput.remark = data;
    // },
    // async save() {
    //   const courseOutlineRegistrationInput = this.input.map(item => {
    //     const input = { ...this.form.filter };
    //     input.academicPeriodId = this.selection.academicPeriod.id; // Fill by filter
    //     input.periodCode = this.selection.academicPeriod.periodCode; // Fill by filter
    //     input.degreeId = item.degree.id;
    //     input.subjectGroupId = item.subjectGroup.id;
    //     input.subjectId = item.subject.id;
    //     input.subjectCode = item.subject.code;
    //     input.subjectName = item.subject.nameLocal;
    //     input.courseOutlineId = item.id;
    //     input.teacherId = item.teacher.id;
    //     input.teacherCode = item.teacherCode;
    //     return input;
    //   });
    //   // this.form.courseOutlineRegistrationInput = courseOutlineRegistrationInput;

    //   const result = await submitForm({ courseOutlineRegistrationInput });

    //   if (result.status.success) {
    //     alert("Add new Course Outline Registration success");
    //     this.local.editor = { active: false };
    //     loadData();
    //   }
    // }
  }
}
</script>

<style lang="scss" scoped>
// @import "common-scoped";

.editor #exam-by-subject-editor {
  width: 100%;
  height: 100%;
  padding-bottom: 100px;

  & .-header {
    width: 100%;
    display: block;
    margin-bottom: 20px;

    & .--title {
      font-size: 2rem;
      color: #6f66b9;
      padding-bottom: 1rem;
      width: 100%;
      height: 3rem;
      border-bottom: 2px solid #e8e8e8;
    }
    & .--subtitle {
      margin-top: 1rem;
      font-size: 1rem;
    }
  }

  & .-body {
    display: flex;
    width: 100%;
    flex-direction: column;

    & .--title {
      margin-bottom: 20px;
      margin-top: 20px;
      text-align: center;

      & > span {
        font-size: 1.4rem;
        font-weight: 400;
      }
    }

    & .--item-container {
      display: block;
      width: 100%;

      & .--item {
        display: block;
        width: 100%;
        margin-bottom: 10px;
      }
    }

    & .--controllers {
      margin-top: 20px;
    }
  }
}
</style>
